import ImageCarousel from "../App/ImageCarousel";

export default function Dashboard() {
  return (
    <>
      <div className="p-relative flow-hidden w-100 flex-d">
        <video autoPlay loop muted className="banner-video" controls={false}>
          <source src="/images/video4.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-title">
          <div
            className="hero-text"
            style={{
              backgroundImage: "url('/images/text-mask7.jpg')",
            }}
          >
            Experience the History
          </div>
        </div>
      </div>
      <ImageCarousel />
    </>
  );
}
